import React, { useCallback, useEffect, useMemo } from 'react';
import _sortBy from 'lodash/sortBy';
import _isObject from 'lodash/isObject';
import _map from 'lodash/map';
import _isEmpty from 'lodash/isEmpty';
import { useDispatch, useMappedState } from 'redux-react-hook';
import { getAPIVersionNumber, getFirstQuestion, getTreatmentCategoryWithCodeName } from 'redux/actions/consultation';
import { getTreatmentCategories } from 'redux/actions/treatmentCategories';
import { getClinicalTemplateVersionFromCondition } from 'redux/selectors/consultation';
import HomeBanner from 'styles/blocks/homeBanner';
import TextField from 'styles/blocks/textField';
import { Tooltip } from './templateTooltip';

export function TreatmentSearch() {
  const mapState = useCallback(state => ({
    treatmentCategories: state.treatmentCategoriesReducer.treatmentCategories,
    error: state.treatmentCategoriesReducer.error,
  }), []);
  const { treatmentCategories, error } = useMappedState(mapState);

  const sortedTreatmentCategories = useMemo(() => _sortBy(treatmentCategories, ['name']), [treatmentCategories]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAPIVersionNumber());
    if (_isEmpty(treatmentCategories)) {
      dispatch(getTreatmentCategories());
    }
  }, [dispatch, treatmentCategories]);

  return (
    <div>
      <HomeBanner>
        <HomeBanner.Title>
          Send your problem or request to your own NHS GP and get a response fast
        </HomeBanner.Title>
        <TextField>Search</TextField>
        <HomeBanner.Title>
          Some things you can ask for help with:
        </HomeBanner.Title>
        <pre>{_isObject(error) ? JSON.stringify(error) : error}</pre>
        <HomeBanner.ButtonContainer>
          <HomeBanner.Button
            onClick={() => dispatch(getFirstQuestion())}
          >
            <HomeBanner.ButtonText>Generic Preliminary</HomeBanner.ButtonText>
          </HomeBanner.Button>
          {_map(sortedTreatmentCategories, (treatmentCategory, i) => (
            <HomeBanner.Button
              key={`treatmentCategoryButton-${i}`}
              onClick={() => dispatch(getTreatmentCategoryWithCodeName(treatmentCategory.codeName))}
            >
              <HomeBanner.ButtonText>{treatmentCategory.name}</HomeBanner.ButtonText>
              <Tooltip
                key={`template-tooltip-${i}`}
                templates={treatmentCategory.templates}
                conditionVersion={treatmentCategory.version}
              >
                Clinical Template version: {getClinicalTemplateVersionFromCondition(treatmentCategory.templates, treatmentCategory.codeName)}
              </Tooltip>
            </HomeBanner.Button>
          ))}
        </HomeBanner.ButtonContainer>
      </HomeBanner>
    </div>
  );
}
